import { useMutation, useQuery } from '@apollo/client/react';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { withTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import Error from '../../components/Atoms/Error';
import Loader from '../../components/Atoms/Loader';
import BrickfilmForm from '../../components/Forms/BrickfilmForm';
import { useCurrentUser } from '../../contexts/CurrentUserContext';
import { useLayoutInfo } from "../../hooks/useLayoutUpdate";
import ErrorPage from '../Shared/ErrorPage';

import EditBrickfilmMutationGQL from './EditBrickfilmMutation.graphql';
import GetBrickfilmQueryGQL from './GetBrickfilmQuery.graphql';

export const EditBrickfilmView = ({ t }) => {
  

  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useCurrentUser();

  const [editBrickfilmMutation, { loading: loadingEdit }] = useMutation(EditBrickfilmMutationGQL);
  const { loading, error, data } = useQuery(GetBrickfilmQueryGQL, { variables: { id } });

  const brickfilm = data?.node;

  useLayoutInfo({
    title: t('Edit a brickfilm'),
    history: [{ title: t('Brickfilms'), action: '/brickfilms/' },
    ...(brickfilm ?
      [
        { title: brickfilm.title, action: `/brickfilms/${brickfilm.id}/${brickfilm.slug}` },
        { title: t('Edit') },
      ] : []),
    ]
  });

  if (loading) return <Loader />;
  if (error) return <Error icon={faTriangleExclamation} message={t('An error occurred while loading the brickfilm.')} />;


  if (!brickfilm) {
    return <ErrorPage type="not-found" />;
  }

  const onCreateBrickfilm = async (data) => {
    const brickfilmData = await editBrickfilmMutation({
      variables: {
        input: {
          ...data,
          picturePath: data.picturePath || '',
          videoLinks: data.videoLinks.map(e => e.link),
          teaserLinks: data.teaserLinks.map(e => e.link),
          productionNotes: data.productionNotes.map(e => ({ id: e.id, content: e.content })).filter(e => Boolean(e.content)),
          castMembers: data.castMembers.map(cast => ({
            memberId: cast?.user?.member?.id || null,
            memberName: cast?.user?.memberName || '',
            role: cast.role,
            additionnalInformation: cast.additionnalInformation,
          })),
          id: undefined,
          brickfilmId: id,
        }
      }
    });

    if (brickfilmData?.data?.editBrickfilm?.brickfilm?.id) {
      const brickfilm = brickfilmData.data.editBrickfilm.brickfilm;
      navigate(`/brickfilms/${brickfilm.id}/${brickfilm.slug}`);
    }
  };

  return (
    <>
      <BrickfilmForm user={user} brickfilm={brickfilm} onSubmit={onCreateBrickfilm} loading={loadingEdit} buttonLabel={t('Save')} />
    </>
  );
};

export default withTranslation()(EditBrickfilmView);
